import {validateSpecialInput} from './validateRules'

/**
 * 填写中文和英文大小写和符号 最多100个字
 * @param maxWord
 * @returns {Function}
 */
export const validateBankName = (isMust= true,maxWord = 100)=>{
  const regSpecial = new RegExp("[`~!@#$^&*=|{}':;',\\[\\].<>/?~！@#￥……&*——|{}【】‘；：”“'。，、？]");
  return (rule, value, callback) => {
    const reg = /[\u4e00-\u9fa5]|[A-Z]|[a-z]+$/i;
    if(isMust && (!value || value.length ===0)){
      callback(new Error('请输入此字段'));
      return
    }
    if (value && (regSpecial.test(value) || !reg.test(value))){
      callback(new Error('非法字符,请重新输入!'))
    }if(value && reg.test(value) && value.length>maxWord){
      callback(new Error(`最多可输入${maxWord}字!`))
    }else {
      callback()
    }
  }
};
/**
 * 填写12个阿拉伯数字
 */
export const validateBankNo = (rule, value, callback) => {
  const reg = /^\d{12}$/;
  if(!value || value.length ===0){
    callback(new Error('请输入此字段'));
  }else if (value && !reg.test(value)) {
    callback(new Error('请正确输入12位银行行号!'))
  }else {
    callback()
  }
};

/***导出规则***/
export const filterFormRules ={
  branchName: [
    { validator: validateSpecialInput(),trigger: 'blur'}
  ],
  bankNo:[
    { validator: validateSpecialInput(),trigger: 'blur'}
  ]
};

export const addBlankFormRules = {
  bankName:[
    {required: true,validator: validateBankName(),trigger: 'blur'}
  ],
  bankCorpName:[
    {required: true,message: '请正确输入银行简称'}
  ],
  branchName:[
    {required: true,validator: validateBankName(),trigger: 'blur'}
  ],
  bankNo:[
    {required: true,validator:validateBankNo,trigger: 'blur'}
  ]
};
/**
 * 银行名称管理验证规则
 */
export const blankCorpFormRules = {
  bankName:[
    {required: true,validator: validateBankName(true,50),trigger: 'blur'}
  ],
  bankCorpName:[
    {required: true,validator: validateBankName(true,30),trigger: 'blur'}
  ],
};
